

/*
vim: fileformat=unix syntax=JavaScript tabstop=4 shiftwidth=4 expandtab fileencoding=utf8
*/
/* jslint browser: true */

import $ from 'jquery';

import PNotify from 'pnotify/lib/umd/PNotify';
import 'pnotify/lib/umd/PNotifyMobile';
import 'pnotify/lib/umd/PNotifyButtons';
import 'pnotify/lib/umd/PNotifyConfirm';

import moment from 'moment';
import 'moment/locale/it';
import 'moment-timezone';

import numeral from 'numeral';
import 'numeral/locales/it';

import validate from 'jquery-validation';
import 'jquery-validation/dist/localization/messages_it';

import datetimepicker from 'eonasdan-bootstrap-datetimepicker';

import DataTable from 'datatables.net-dt';


PNotify.defaults.modules = {
    Buttons: {
        closerHover: false,
        stickerHover: false,
        labels: {
            close: 'Chiuso',
            stick: 'Stick',
            unstick: 'Unstick',
        },
    },
    Mobile: {},
};
PNotify.defaults.styling = 'bootstrap3';
PNotify.defaults.icons = 'fontawesome4';
export { PNotify };


moment.locale('it');
moment.tz.add('Etc/UTC|UTC|0|0|');
// eslint-disable-next-line max-len
moment.tz.add('Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2as10 M00 1cM0 1cM0 14o0 1o00 WM0 1qM0 17c0 1cM0 M3A0 5M20 WM0 1fA0 1cM0 16K0 1iO0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 Lz0 1C10 Lz0 1EN0 Lz0 1C10 Lz0 1zd0 Oo0 1C00 On0 1C10 Lz0 1zd0 On0 1C10 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00');

//using browser timezone
moment.tz.setDefault();
//    moment.tz.setDefault("Europe/Rome");
export { moment };


export { numeral };

export { validate };

$.fn.datetimepicker.defaults.icons = {
    time: 'fa fa-clock-o',
    date: 'fa fa-calendar',
    up: 'fa fa-arrow-up',
    down: 'fa fa-arrow-down',
    previous: 'fa fa-chevron-left',
    next: 'fa fa-chevron-right',
    today: 'fa fa-crosshairs',
    clear: 'fa fa-trash',
    close: 'fa fa-times',
};
export { datetimepicker };

//datatables default language
$.extend(true, $.fn.dataTable.defaults, {
    language: {
        //            url: APP_ROOT+"node_modules/datatables.net-plugins/i18n/Italian.lang?ver="+APP_VER
        'sEmptyTable': 'Nessun dato presente nella tabella',
        'sInfo': 'Vista da _START_ a _END_ di _TOTAL_ elementi',
        'sInfoEmpty': 'Vista da 0 a 0 di 0 elementi',
        'sInfoFiltered': '(filtrati da _MAX_ elementi totali)',
        'sInfoPostFix': '',
        'sInfoThousands': '.',
        'sLengthMenu': 'Visualizza _MENU_ elementi',
        'sLoadingRecords': 'Caricamento...',
        'sProcessing': 'Elaborazione...',
        'sSearch': 'Cerca:',
        'sZeroRecords': 'La ricerca non ha portato alcun risultato.',
        'oPaginate': {
            'sFirst': 'Inizio',
            'sPrevious': 'Precedente',
            'sNext': 'Successivo',
            'sLast': 'Fine',
        },
        'oAria': {
            'sSortAscending': ': attiva per ordinare la colonna in ordine crescente',
            'sSortDescending': ': attiva per ordinare la colonna in ordine decrescente',
        },
        'select': {
            'rows': {
                _: '',
                0: '',
                1: '',
            },
        },
    },
    dom: 'Bfrtlip',
});
export { DataTable };
